// src/components/pdf-table/SelectionCheckbox.js
import React from 'react';
import { Check, Minus, X, LockKeyhole } from 'lucide-react';

const SelectionCheckbox = ({
  checked = false,
  indeterminate = false,
  onChange,
  disabled = false,
  variant = 'check', // 'check' or 'x'
  locked = false,    // Renders a non-interactive lock icon
  noHoverBorder = false, // Suppresses hover border color change
  darkMode = false,  // Dark background variant (for use on dark surfaces)
  ...rest
}) => {
  // If locked, render a non-interactive lock icon instead
  if (locked) {
    return (
      <div
        {...rest}
        className={`
          w-[14px] h-[14px] rounded-app-2xs
          flex items-center justify-center
          ${darkMode
            ? checked
              ? 'bg-app-gray-200 border border-app-gray-200'
              : 'bg-app-gray-800 border border-app-gray-400'
            : checked
              ? 'bg-app-gray-800 border border-app-gray-800'
              : 'bg-white border border-app-gray-400'
          }
        `}
      >
        <LockKeyhole
          size={9}
          className={
            darkMode
              ? checked ? 'text-app-gray-800' : 'text-app-gray-400'
              : checked ? 'text-white' : 'text-app-gray-400'
          }
          strokeWidth={2.5}
          style={{ marginTop: '0.5px' }}
        />
      </div>
    );
  }

  if (darkMode) {
    return (
      <button
        {...rest}
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) onChange?.(e);
        }}
        disabled={disabled}
        className={`
          w-[14px] h-[14px] rounded-app-2xs
          flex items-center justify-center
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          ${checked || indeterminate
            ? 'bg-app-gray-200 border border-app-gray-200'
            : `bg-app-gray-800 border border-app-gray-400 ${noHoverBorder ? '' : 'hover:border-app-white'}`
          }
        `}
      >
        {checked && variant === 'check' && <Check size={10} className="text-app-gray-800" strokeWidth={4} />}
        {checked && variant === 'x' && <X size={10} className="text-app-gray-800" strokeWidth={4} />}
        {indeterminate && <Minus size={10} className="text-app-gray-800" strokeWidth={4} />}
      </button>
    );
  }

  return (
    <button
      {...rest}
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange?.(e);
      }}
      disabled={disabled}
      className={`
        w-[14px] h-[14px] rounded-app-2xs
        flex items-center justify-center
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${checked || indeterminate
          ? 'bg-app-gray-800 border border-app-gray-800'
          : `bg-white border border-app-gray-400 ${noHoverBorder ? '' : 'hover:border-app-gray-800'}`
        }
      `}
    >
      {checked && variant === 'check' && <Check size={10} className="text-white" strokeWidth={4} />}
      {checked && variant === 'x' && <X size={10} className="text-white" strokeWidth={4} />}
      {indeterminate && <Minus size={10} className="text-white" strokeWidth={4} />}
    </button>
  );
};

export default SelectionCheckbox;